const correspondenceTableForLabourHours = {
  25: 15, // .25 in db => 15 minutes
  5: 30, // .50 in db => 30 minutes
  75: 45, // .75 in db => 45 minutes
};

export const getCorrespondenceForLabourHours = (input) => {
  return correspondenceTableForLabourHours[input];
};
